import dayjs from "dayjs";
import { safeParse } from "./safeParse";

export function isClosedToday(key) {
  const storage = safeParse(localStorage.getItem(key));

  let hasClosed = false;

  if (storage) {
    hasClosed = storage.state && storage.expire >= Date.now();
  }

  return {
    hasClosed,
    onCloseRecord() {
      localStorage.setItem(
        key,
        JSON.stringify({
          state: true,
          // 过期时间,当天有效
          expire: dayjs().endOf("date").valueOf(),
        })
      );
    },
  };
}
